import {$body, $window} from './references.js';

// console.log('Site:dom');

// Moves the icons from the a::after into the DOM and removes the after
export function moveIconsIntoDom($menu) {
  // console.log('Site:social:moveIconsIntoDom');
  // console.log('$menu', $menu);

  const $links = $menu.find('a');

  for (let i = $links.length - 1; i >= 0; i--) {
    const style = window.getComputedStyle($links[i], ':after');

    if (!style) {
      continue;
    }

    const regex = /(%3C.*%3E)/gm;

    let matches;

    while ((matches = regex.exec(style.content)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (matches.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      if (matches.length) {
        try {
          const template = document.createElement('div');

          template.innerHTML = decodeURI(matches[0]).replace('%23', '#');
          $links[i].appendChild(template.children[0]);
          $links[i].classList.add('icon-in-dom');
        } catch (e) {
          console.log('moveIconsIntoDom error', e);
        }
      }

      break;
    }
  }
}


/**
 * Prevents/allows the body to scroll.
 *
 * Used when modals are visible to block scroll chaining.
 *
 * @since 0.1.0
 *
 * @param bool enabled Whether the body can scroll.
 */
export function setBodyScrollingEnabled(enabled) {
  if (enabled) {
    // Allow the parent document to be scrollable again
    $body.removeClass('scrolling-disabled').css({
      position : 'inherit',
      width    : 'inherit',
      top      : 'inherit',
    });
    $window.scrollTop(-1 * parseInt($body.css('top'), 10));
  } else {
    $body.css({
      position : 'fixed',
      width    : '100%',
      top      : '-' + $window.scrollTop() + 'px',
    });
  }
}
